export default __webpack_public_path__ + "static/media/image-map-canada.dce629d0.png";